import { render, staticRenderFns } from "./realQty.vue?vue&type=template&id=3af78cf8&scoped=true"
import script from "./realQty.vue?vue&type=script&lang=js"
export * from "./realQty.vue?vue&type=script&lang=js"
import style0 from "./realQty.vue?vue&type=style&index=0&id=3af78cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af78cf8",
  null
  
)

export default component.exports